import React from 'react';
import { IconWrapper } from '../../styledComponents';

interface IProps {
	rotating: boolean;
	img: string;
}

function Icon(props: IProps) {
	const { rotating, img } = props;
	return (
		<IconWrapper rotating={rotating}>
			<img src={img} alt="" />
		</IconWrapper>
	);
}

export default Icon;
